export default class PageTransition{

    /**
     * Cache la page
     * @param cb
     */
    hidePage(cb){
        if(cb){
            cb();
        }
    }

    /**
     * Montre la page
     * @param cb
     */
    showPage(cb){
        if(cb){
            cb();
        }
    }
}


// WEBPACK FOOTER //
// ./fk.app/_src/transitions/PageTransition.js